// Define shape of slice

export const OPEN = "OPEN" // Display the dialog
export const CLOSED = "CLOSED" // Initial state - used when dialog is not required
export const SUPPRESSED = "SUPPRESSED" // Used once user has completed the dialog
export type AccountDialogState = typeof OPEN | typeof CLOSED | typeof SUPPRESSED
